import { render, staticRenderFns } from "./teleport.vue?vue&type=template&id=61444708&"
import script from "./teleport.vue?vue&type=script&lang=js&"
export * from "./teleport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports